import baseUrl from "../config/baseUrl";

const getClientName = async ({ token, contact_id }) => {
  try {
    const response = await fetch(`${baseUrl}/api/get-client-name?contact_id=${contact_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default getClientName;
